var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoonheffingGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.93 202.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #a6a6a6;\n      }\n\n      .cls-3 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-4 {\n        fill: #767676;\n      }\n\n      .cls-5 {\n        fill: #ffc727;\n      }\n\n      .cls-6, .cls-7 {\n        opacity: .1;\n      }\n\n      .cls-8 {\n        fill: #7329e8;\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        fill: #263238;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 160.48,
    y1: 43.45,
    x2: 117.57,
    y2: 34.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 4.34,
    y: 5.4,
    width: 168.26,
    height: 197.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 23.47,
    y: 24.15,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.55,
    y: 17.53,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30.4,
    y: 17.53,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 141.04,
    y: 17.53,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.96,
    y: 159.88,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 43.5,
    y: 79.59,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 50.43,
    y: 86.2,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 65.67,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 65.67,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 37.77,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 37.77,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.34,
    y: 43.07,
    width: 168.26,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 2.77,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 2.77,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 197.34,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    y: 197.34,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 10.51,
    y: 75.58,
    width: 42.02,
    height: 23.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.54 75.58 52.54 86.88 40.05 99.37 26.07 99.37 49.85 75.58 52.54 75.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.38 75.58 12.59 99.37 10.51 99.37 10.51 98.48 33.42 75.58 36.38 75.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.01 75.58 10.51 91.08 10.51 85.29 20.22 75.58 26.01 75.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.54 90.9 52.54 96.69 49.86 99.37 44.08 99.37 52.54 90.9"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.08,
    y: 72.88,
    width: 104.36,
    height: 94.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 63.66,
    y: 75.58,
    width: 99.17,
    height: 89.03
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 135.85 162.84 149.83 148.06 164.6 134.08 164.6 162.84 135.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.8 75.58 63.66 148.72 63.66 134.74 122.83 75.58 136.8 75.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.51 75.58 63.66 157.43 63.66 154.48 142.56 75.58 145.51 75.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 113.37 162.84 116.32 114.54 164.6 111.6 164.6 162.84 113.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 155.17 162.84 160.94 159.17 164.6 153.39 164.6 162.84 155.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.7 75.58 63.66 122.62 63.66 116.83 104.91 75.58 110.7 75.58"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 149.94,
    y: 112.1,
    width: 36.97,
    height: 0.51,
    transform: "translate(31.32 261.33) rotate(-81.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.52,130.6c0,.55.45,1,1,1s1-.45,1-1c0-.55-.45-1-1-1h0c-.55,0-1,.45-1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 57.96,
    y: 93.84,
    width: 0.51,
    height: 36.97,
    transform: "translate(-16.64 10.33) rotate(-8.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.08,130.6c0,.55-.45,1-1,1s-1-.45-1-1c0-.55.45-1,1-1h0c.55,0,1,.45,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m52.28,93.72h121.93c-7.3-12.65-8.75-22.75-8.75-22.75H61.03s-1.43,10.1-8.75,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m52.28,93.72v2.69c-.06,1.31.95,2.43,2.26,2.5h4.86c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5v-2.69s-121.93,0-121.93,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 34.09,
    y: 166.49,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.51,
    y: 104.39,
    width: 42.02,
    height: 98.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 16.76,
    y: 110.8,
    width: 29.52,
    height: 48.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 110.8,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 112.34,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 113.88,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 115.4,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 116.94,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 118.48,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 120.02,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 121.55,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 123.09,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 124.63,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 126.17,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 127.7,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 129.24,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 130.78,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 132.32,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 133.85,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 135.39,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 136.93,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 138.47,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 140,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 141.53,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 143.07,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 144.6,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 110.8 46.29 116.62 16.76 146.14 16.76 132.15 38.13 110.8 46.29 110.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 141.3 46.29 155.28 42.51 159.05 28.54 159.05 46.29 141.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 135.18 46.29 138.13 25.36 159.05 22.41 159.05 46.29 135.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.15 110.8 16.76 129.18 16.76 123.39 29.36 110.8 35.15 110.8"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 19.4,
    y: 164.5,
    width: 22.13,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 161.37,
    width: 2.59,
    height: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.76,194.44c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25s-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m46.29,177.47c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.59,191.24c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42.46,180.67c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.76,194.44c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25s-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m46.29,177.47c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m20.59,191.24c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m42.46,180.67c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m52.28,93.72v2.69c-.06,1.31.95,2.43,2.26,2.5h4.86c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5v-2.69s-121.93,0-121.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.78,96.4c0-.9,0-1.8.1-2.69v-.06c-1.05-1.73-1.99-3.53-2.86-5.35-.88-1.82-1.64-3.69-2.36-5.57-.7-1.9-1.29-3.83-1.78-5.79l-.35-1.47c-.1-.5-.16-1-.26-1.5-.22-.99-.28-2-.44-3,.05,2.03.28,4.06.69,6.05.42,2,.98,3.96,1.67,5.88.7,1.92,1.51,3.79,2.43,5.61.45.91.94,1.8,1.46,2.69s1.04,1.75,1.62,2.57h0c.08.84.08,1.74.08,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.45,96.4c0-.9,0-1.8.1-2.69h0c-.51-.85-.99-1.73-1.44-2.61s-.85-1.8-1.25-2.71c-.78-1.83-1.44-3.7-1.99-5.61-.16-.47-.29-.95-.4-1.44-.11-.48-.26-.96-.35-1.45-.2-.97-.42-1.94-.56-2.92-.31-1.97-.52-3.95-.62-5.94-.07,2,.01,4,.26,5.99.51,3.99,1.61,7.89,3.25,11.56.81,1.84,1.79,3.59,2.92,5.25h0c0,.77.03,1.67.08,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.94,96.4c.06-2.13.06-4.24.06-6.36s0-4.24-.07-6.36c-.07-2.12-.1-4.24-.19-6.36l-.14-3.18c-.06-1.06-.11-2.13-.19-3.18,0,1.05,0,2.11-.06,3.18v3.19c0,2.11,0,4.24.07,6.36.07,2.12.11,4.24.2,6.35.09,2.11.16,4.25.31,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.53,96.4c.15-2.11.24-4.24.33-6.36.09-2.12.13-4.24.19-6.35.06-2.11.07-4.25.07-6.36v-3.19c0-1.06,0-2.13-.06-3.18-.07,1.05-.13,2.11-.19,3.18l-.14,3.18c-.09,2.13-.14,4.24-.2,6.36-.06,2.12,0,4.24-.07,6.36-.07,2.12.07,4.24.07,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.28,96.4c0-.9.07-1.8.11-2.69h0c-.25-1.88-.39-3.75-.55-5.66-.16-1.91-.22-3.75-.34-5.68-.11-1.93-.15-3.75-.22-5.7l-.16-5.69c-.06.94-.1,1.89-.15,2.85s0,1.9,0,2.85c0,1.9,0,3.75.09,5.7.09,1.95.22,3.81.4,5.7.09.95.2,1.9.33,2.84.13.94.26,1.89.45,2.83h0c.05.85.05,1.75.05,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.69,96.4c0-.9.07-1.8.11-2.69h0c-.62-1.81-1.1-3.66-1.43-5.54-.18-.95-.33-1.89-.48-2.84-.15-.95-.25-1.9-.36-2.85-.24-1.9-.35-3.81-.51-5.72l-.18-2.87c0-.96-.07-1.93-.14-2.87,0,.95-.06,1.91-.09,2.87s0,1.93,0,2.89c0,1.93.19,3.85.39,5.76.2,1.92.49,3.83.89,5.72.19.94.42,1.88.7,2.8.26.94.58,1.85.97,2.74h0c.05.8.08,1.7.11,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m146.03,96.4c0-.9,0-1.8.1-2.69v-.06c-.84-1.75-1.55-3.56-2.1-5.42-.59-1.86-1.01-3.75-1.41-5.66-.4-1.91-.65-3.84-.88-5.77-.14-.96-.16-1.94-.28-2.9-.11-.96-.1-1.95-.18-2.92v2.92s0,1.47,0,1.47c0,.49,0,.97.09,1.46l.11,1.46c0,.5.13.97.19,1.46.11.97.29,1.94.45,2.91.37,1.93.87,3.83,1.47,5.7.3.94.65,1.85,1.04,2.75.36.91.77,1.8,1.25,2.65h0c.14.84.14,1.74.14,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.67,96.4c0-.9.06-1.8.1-2.69h0c.59-.83,1.11-1.7,1.62-2.57s1.01-1.78,1.46-2.69c.91-1.81,1.71-3.66,2.41-5.56.7-1.91,1.25-3.88,1.66-5.88.42-1.99.65-4.02.69-6.05-.15,1-.21,2.01-.42,3-.1.5-.16,1-.28,1.5l-.34,1.47c-.48,1.96-1.08,3.89-1.79,5.79-.71,1.89-1.46,3.75-2.35,5.57-.89,1.82-1.81,3.62-2.86,5.35v.06c.01.89.04,1.79.09,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.03,96.4c0-.9.07-1.8.1-2.69h0c1.13-1.66,2.11-3.41,2.92-5.25.83-1.83,1.51-3.73,2.05-5.66.57-1.93.99-3.9,1.25-5.9.25-1.99.34-3.99.26-5.99-.11,1.99-.32,3.97-.63,5.94-.15.99-.37,1.95-.56,2.92-.1.49-.24.97-.35,1.45s-.25.96-.4,1.44c-.54,1.91-1.21,3.79-1.99,5.61-.4.91-.8,1.82-1.25,2.71s-.94,1.76-1.45,2.61v.06c.04.94.04,1.84.04,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.17,96.4c0-.9.07-1.8.11-2.69h0c.19-.94.31-1.87.45-2.83s.24-1.89.33-2.84c.16-1.89.33-3.75.39-5.7.06-1.95.14-3.75.1-5.7,0-.95,0-1.9-.06-2.85s-.07-1.91-.14-2.85l-.16,5.69c-.07,1.9-.13,3.75-.22,5.7-.1,1.95-.19,3.75-.35,5.68s-.29,3.75-.54,5.66h0c.04.92.05,1.82.1,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.78,96.4c0-.9.07-1.8.11-2.69h0c.39-.89.72-1.8.97-2.74.26-.92.5-1.86.7-2.8.39-1.89.68-3.8.88-5.72.21-1.91.35-3.84.4-5.76v-2.89c0-.96,0-1.93-.09-2.87-.06.95-.1,1.91-.15,2.87l-.16,2.87c-.16,1.91-.28,3.82-.53,5.72-.1.95-.24,1.9-.36,2.85s-.29,1.89-.48,2.84c-.32,1.88-.79,3.73-1.41,5.54h0c.11.97.11,1.88.11,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.42,96.4c0-.9.07-1.8.1-2.69h0c.48-.85.89-1.74,1.25-2.65.4-.9.74-1.82,1.04-2.75.61-1.87,1.11-3.77,1.47-5.7.16-.97.35-1.94.46-2.91.06-.49.14-.96.18-1.46l.13-1.46c0-.48.02-.97.07-1.46v-1.47c0-.97,0-1.95,0-2.92-.07.97-.11,1.95-.19,2.92s-.14,1.94-.26,2.9c-.22,1.94-.5,3.88-.88,5.77s-.84,3.75-1.43,5.66c-.54,1.86-1.24,3.68-2.09,5.42v.06c.06.94.09,1.84.14,2.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.93,190.13c.1-1.43.14-2.84.2-4.25.06-1.41.1-2.83.15-4.25.07-2.83.11-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.22,0-4.44,0-6.66,0s-4.44.09-6.66.16c-1.11,0-2.22.09-3.33.13l-3.34.16c1.11.07,2.22.11,3.34.16,1.11.05,2.21.1,3.33.13,2.22.07,4.45.13,6.66.16s4.45,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.15,8.49,0,1.43.07,2.84.15,4.25.07,1.41.04,2.9.19,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.4,173.14c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.14,4.24-.07,2.84-.11,5.66-.15,8.5v.49s.49,0,.49,0h6.74c2.25,0,4.49,0,6.73-.06s4.49-.07,6.74-.15l3.36-.14,3.38-.15c-1.12-.07-2.25-.13-3.38-.16l-3.36-.14c-2.25-.07-4.49-.11-6.74-.15-2.25-.04-4.49-.06-6.73-.06h-6.74s.49.5.49.5c0-2.84-.06-5.66-.14-8.5,0-1.41-.09-2.83-.15-4.24-.06-1.41-.11-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.1,186.92c.07-1.76.14-3.53.16-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.24,0-.24,0h-4.94s-4.94,0-4.94,0c-1.64,0-3.29,0-4.93.07-1.64.07-3.3.09-5,.15,1.64.06,3.29.13,5,.15,1.71.02,3.29.07,4.93.07h4.94s4.94,0,4.94,0l-.22-.22v2.65s0,2.64,0,2.64c.22,1.76.22,3.53.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.23,176.34c-.06,1.76-.13,3.53-.15,5.29-.02,1.76-.07,3.53-.07,5.29v.22s.22,0,.22,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.24.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.09-3.53-.16-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.19,186.92c.06-1.76.13-3.53.15-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.22,0-.22,0h-4.94s-4.94,0-4.94,0c-1.65,0-3.29,0-4.94.07l-4.94.15c1.65.06,3.3.13,4.94.15,1.64.02,3.29.07,4.94.07h4.94s4.94,0,4.94,0l-.22-.22v2.65s0,2.64,0,2.64c.17,1.76.24,3.53.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.28,176.34c0,1.76-.13,3.53-.15,5.29s-.07,3.53-.07,5.29v.22s.22,0,.22,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.22.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.05-3.53-.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.01,190.13c.09-1.43.14-2.84.2-4.25s.1-2.83.14-4.25c.07-2.83.13-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.21,0-4.45,0-6.66,0s-4.45.09-6.66.16c-1.11,0-2.22.09-3.34.13l-3.33.16c1.1.07,2.21.11,3.33.16,1.11.05,2.22.1,3.34.13,2.21.07,4.44.13,6.66.16s4.44,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.14,8.49,0,1.43.09,2.84.15,4.25.06,1.41.13,2.9.21,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.53,173.14c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.15,4.24-.07,2.84-.11,5.66-.15,8.5v.49s.5,0,.5,0h6.73c2.24,0,4.49,0,6.74-.06s4.49-.07,6.73-.15l3.38-.14c1.12,0,2.24-.09,3.36-.15-1.12-.07-2.24-.13-3.36-.16l-3.38-.14c-2.24-.07-4.49-.11-6.73-.15-2.24-.04-4.49-.06-6.74-.06h-6.73s.49.5.49.5c0-2.84-.07-5.66-.15-8.5,0-1.41-.07-2.83-.14-4.24s-.2-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.28,186.92c.06-1.76.13-3.53.15-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.15,0-.15,0h-4.94s-4.94,0-4.94,0c-1.65,0-3.29,0-5,.07-1.71.07-3.29.09-4.94.15,1.65.06,3.29.13,4.94.15,1.65.02,3.29.07,5,.07l4.88.07h4.94s-.24-.22-.24-.22v2.65s0,2.64,0,2.64c.17,1.69.22,3.45.3,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.4,176.34c-.07,1.76-.13,3.53-.16,5.29-.04,1.76-.06,3.53-.07,5.29v.22s.24,0,.24,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.22.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.09-3.53-.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.03,190.13c.09-1.43.14-2.84.2-4.25s.1-2.83.15-4.25c.07-2.83.11-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.22,0-4.44,0-6.66,0s-4.44.09-6.66.16c-1.11,0-2.22.09-3.33.13l-3.34.16c1.11.07,2.22.11,3.34.16,1.11.05,2.21.1,3.33.13,2.22.07,4.44.13,6.66.16s4.45,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.15,8.49,0,1.43.07,2.84.14,4.25s.2,2.9.2,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.56,173.14c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.14,4.24-.07,2.84-.13,5.66-.15,8.5v.49s.49,0,.49,0h6.74c2.25,0,4.49,0,6.73-.06s4.49-.07,6.74-.15l3.36-.14,3.38-.15c-1.12-.07-2.25-.13-3.38-.16l-3.36-.14c-2.25-.07-4.49-.11-6.74-.15-2.25-.04-4.49-.06-6.73-.06h-6.74s.49.5.49.5c0-2.84-.06-5.66-.14-8.5,0-1.41-.09-2.83-.15-4.24s-.11-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m18.1,56.57v2.14h-6.1v-8.4h2.75v6.25h3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m18.49,54.51c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m27.78,54.51c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m45.55,50.31v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.9,50.31v8.4h-2.74v-3.13h-2.67v3.13h-2.75v-8.4h2.75v3.13h2.67v-3.13h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m58.84,52.45v1.15h3.4v1.81h-3.4v1.15h4.07v2.14h-6.82v-8.4h6.82v2.14h-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.71,52.45v1.19h3.14v1.9h-3.14v3.17h-2.75v-8.4h6.57v2.14h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m74.17,52.45v1.19h3.14v1.9h-3.14v3.17h-2.75v-8.4h6.57v2.14h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m81.64,58.71h-2.75v-8.4h2.75v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m91.09,50.31v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m96.26,52.3c-.98,0-1.6.7-1.6,2.21s.62,2.21,1.6,2.21c.77,0,1.34-.47,1.49-1.31h-1.79v-1.61h4.57v4.91h-1.92l-.1-1.18c-.44.88-1.22,1.35-2.65,1.35-2.25,0-3.95-1.43-3.95-4.37s1.7-4.37,4.34-4.37c2.25,0,3.89,1.03,4.2,3.12h-2.82c-.16-.62-.71-.97-1.38-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m106.39,52.51c-.17-.31-.56-.49-1.11-.49-.65,0-1.09.19-1.09.56,0,.5,1.31.77,2.48,1.1,1.58.45,2.61,1.1,2.62,2.43.01,1.65-1.3,2.76-3.89,2.76-2.03,0-3.38-.84-3.85-2.06-.13-.29-.2-.6-.2-.91h2.76c0,.14.03.29.11.41.17.32.61.55,1.23.55s1.07-.25,1.07-.64c0-.59-1.27-.78-2.35-1.08-1.47-.4-2.64-1.15-2.64-2.35,0-1.69,1.49-2.65,3.95-2.65,1.87,0,3.16.77,3.57,1.94.1.27.16.56.15.87h-2.69c0-.17-.04-.32-.13-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m112.85,53.84l2.36-3.53h3.11l-2.95,4.2,3,4.2h-3.17l-2.36-3.53v3.53h-2.75v-8.4h2.75v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m118.06,54.51c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m135.45,53.25c0,1.16-.5,2.09-1.39,2.59l1.72,2.87h-2.88l-1.38-2.46h-1.21v2.46h-2.75v-8.4h4.82c1.91,0,3.06,1.23,3.06,2.94Zm-3.68,1.02c.59,0,.94-.32.94-.97s-.35-.97-.94-.97h-1.46v1.93h1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m143.01,52.45h-2.21v6.25h-2.74v-6.25h-2.21v-2.14h7.16v2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m146.49,58.71h-2.75v-8.4h2.75v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m155.94,50.31v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m161.12,52.3c-.98,0-1.6.7-1.6,2.21s.62,2.21,1.6,2.21c.77,0,1.34-.47,1.49-1.31h-1.79v-1.61h4.57v4.91h-1.92l-.1-1.18c-.44.88-1.22,1.35-2.65,1.35-2.25,0-3.95-1.43-3.95-4.37s1.7-4.37,4.34-4.37c2.25,0,3.89,1.03,4.2,3.12h-2.82c-.16-.62-.71-.97-1.38-.97Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m176.93,8.07V2.77H0v5.3h4.34v29.7H0v5.3h4.34v22.6H0v5.3h4.34v126.38H0v5.3h176.92v-5.3h-4.33v-98.58c.97-.34,1.65-1.28,1.6-2.36v-2.69c-.57-.99-1.1-1.96-1.6-2.91v-19.84h4.33v-5.3h-4.33v-22.6h4.33v-5.3h-4.33V8.07h4.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m158.31,32.21l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.23,48.99c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoonheffingGesloten);
export default __webpack_public_path__ + "static/media/loonheffing-gesloten.33e388f41ba8861c4a213eb31d659db0.svg";
export { ForwardRef as ReactComponent };